import { useState, useEffect, useCallback } from "react";
import { t, getLang } from "./i18n";

var dLoc = function(){ return ({ pt: "pt-BR", es: "es-ES", en: "en-US" })[getLang()] || "pt-BR"; };

const API = window.location.origin;
const getToken = () => sessionStorage.getItem("aurora_token");
const ftch = async (url, opts = {}) => {
  const r = await fetch(API + url, { ...opts, headers: { "Content-Type": "application/json", Authorization: "Bearer " + getToken(), ...opts.headers } });
  const d = await r.json();
  if (!r.ok) throw new Error(d.error || "Erro");
  return d;
};

const h1Style = { fontSize: 20, fontWeight: 600, color: "#1F2937", margin: 0 };
const subStyle = { fontSize: 13, color: "#9CA3AF", marginTop: 2 };
const pBtn = { background: "#F59E0B", border: "none", borderRadius: 8, padding: "9px 18px", color: "#FFF", fontWeight: 500, fontSize: 14, cursor: "pointer", fontFamily: "inherit" };
const sBtn = { background: "#FFF", border: "1px solid #E2E8F0", borderRadius: 8, padding: "9px 18px", color: "#64748B", fontWeight: 500, fontSize: 13, cursor: "pointer", fontFamily: "inherit" };
const iStyle = { width: "100%", padding: "10px 12px", border: "1px solid #E2E8F0", borderRadius: 8, fontSize: 14, fontFamily: "inherit", outline: "none", boxSizing: "border-box" };
const cardStyle = { background: "#FFF", border: "1px solid #E8EAF0", borderRadius: 10, padding: 16, cursor: "pointer", transition: "box-shadow 0.15s" };

const priorityColors = { baixa: "#10B981", normal: "#F59E0B", alta: "#EF4444", urgente: "#DC2626" };
const statusLabels = function(st){ return t("tk.st_" + st); };
const statusColors = { aberto: "#F59E0B", em_atendimento: "#3B82F6", fechado: "#6B7280" };

export default function TicketsPage() {
  const [tickets, setTickets] = useState([]);
  const [tab, setTab] = useState("aberto");
  const [selected, setSelected] = useState(null);
  const [detail, setDetail] = useState(null);
  const [showNew, setShowNew] = useState(false);
  const [newSubject, setNewSubject] = useState("");
  const [newDesc, setNewDesc] = useState("");
  const [newPriority, setNewPriority] = useState("normal");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [rating, setRating] = useState(0);
  const [ratingComment, setRatingComment] = useState("");

  const loadTickets = useCallback(async () => {
    try {
      const data = await ftch("/api/tickets?status=" + tab);
      setTickets(data);
    } catch (e) { console.error(e); }
  }, [tab]);

  useEffect(() => { loadTickets(); setSelected(null); setDetail(null); }, [loadTickets]);

  const loadDetail = async (id) => {
    try {
      const data = await ftch("/api/tickets/" + id);
      setDetail(data);
      setSelected(id);
    } catch (e) { console.error(e); }
  };

  const createTicket = async () => {
    if (!newSubject.trim()) return alert(t("tk.subjectRequired"));
    setLoading(true);
    try {
      await ftch("/api/tickets", { method: "POST", body: JSON.stringify({ subject: newSubject, description: newDesc, priority: newPriority }) });
      setNewSubject(""); setNewDesc(""); setNewPriority("normal"); setShowNew(false);
      loadTickets();
    } catch (e) { alert(e.message); } finally { setLoading(false); }
  };

  const sendMessage = async () => {
    if (!msg.trim() || !selected) return;
    setLoading(true);
    try {
      await ftch("/api/tickets/" + selected + "/messages", { method: "POST", body: JSON.stringify({ message: msg }) });
      setMsg("");
      loadDetail(selected);
    } catch (e) { alert(e.message); } finally { setLoading(false); }
  };

  const submitRating = async () => {
    if (!rating) return alert(t("tk.rateRequired"));
    setLoading(true);
    try {
      await ftch("/api/tickets/" + selected + "/rate", { method: "POST", body: JSON.stringify({ rating, rating_comment: ratingComment }) });
      setRating(0); setRatingComment("");
      loadDetail(selected);
      loadTickets();
    } catch (e) { alert(e.message); } finally { setLoading(false); }
  };

  const fmtDate = (d) => { if (!d) return ""; const dt = new Date(d); return dt.toLocaleDateString(dLoc()) + " " + dt.toLocaleTimeString(dLoc(), { hour: "2-digit", minute: "2-digit" }); };

  // === FORMULÁRIO NOVO TICKET ===
  if (showNew) return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18 }}>
        <div><h1 style={h1Style}>{t("tk.newTitle")}</h1><div style={subStyle}>{t("tk.newSub")}</div></div>
        <button onClick={() => setShowNew(false)} style={sBtn}>{t("tk.back")}</button>
      </div>
      <div style={{ background: "#FFF", border: "1px solid #E8EAF0", borderRadius: 10, padding: 24, maxWidth: 560 }}>
        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 13, fontWeight: 500, color: "#374151", marginBottom: 4, display: "block" }}>{t("tk.subject")}</label>
          <input value={newSubject} onChange={e => setNewSubject(e.target.value)} placeholder={t("tk.subjectPh")} style={iStyle} autoFocus />
        </div>
        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 13, fontWeight: 500, color: "#374151", marginBottom: 4, display: "block" }}>{t("os.desc")}</label>
          <textarea value={newDesc} onChange={e => setNewDesc(e.target.value)} placeholder={t("tk.descPh")} rows={5} style={{ ...iStyle, resize: "vertical" }} />
        </div>
        <div style={{ marginBottom: 18 }}>
          <label style={{ fontSize: 13, fontWeight: 500, color: "#374151", marginBottom: 4, display: "block" }}>{t("tk.priority")}</label>
          <div style={{ display: "flex", gap: 8 }}>
            {["baixa", "normal", "alta", "urgente"].map(p => (
              <button key={p} onClick={() => setNewPriority(p)} style={{ ...sBtn, background: newPriority === p ? priorityColors[p] : "#FFF", color: newPriority === p ? "#FFF" : "#64748B", textTransform: "capitalize", fontSize: 13, padding: "7px 14px" }}>{t("tk.pr_" + p)}</button>
            ))}
          </div>
        </div>
        <button onClick={createTicket} disabled={loading} style={{ ...pBtn, width: "100%", opacity: loading ? 0.6 : 1 }}>{loading ? t("tk.creating") : t("tk.openTicket")}</button>
      </div>
    </div>
  );

  // === DETALHE DO TICKET ===
  if (selected && detail) return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18 }}>
        <div>
          <h1 style={h1Style}>#{detail.id} — {detail.subject}</h1>
          <div style={{ display: "flex", gap: 12, marginTop: 4 }}>
            <span style={{ fontSize: 12, color: statusColors[detail.status], fontWeight: 500 }}>● {statusLabels(detail.status)}</span>
            <span style={{ fontSize: 12, color: priorityColors[detail.priority], fontWeight: 500, textTransform: "capitalize" }}>{t("tk.pr_" + detail.priority)}</span>
            <span style={{ fontSize: 12, color: "#9CA3AF" }}>{fmtDate(detail.created_at)}</span>
          </div>
        </div>
        <button onClick={() => { setSelected(null); setDetail(null); }} style={sBtn}>{t("tk.back")}</button>
      </div>

      {/* Mensagens */}
      <div style={{ background: "#FFF", border: "1px solid #E8EAF0", borderRadius: 10, padding: 20, marginBottom: 16, maxHeight: 420, overflowY: "auto" }}>
        {detail.messages && detail.messages.length > 0 ? detail.messages.map(m => (
          <div key={m.id} style={{ marginBottom: 14, display: "flex", flexDirection: "column", alignItems: m.sender_type === "admin" ? "flex-start" : "flex-end" }}>
            <div style={{ background: m.sender_type === "admin" ? "#EFF6FF" : "#FFFBEB", border: "1px solid " + (m.sender_type === "admin" ? "#BFDBFE" : "#FDE68A"), borderRadius: 10, padding: "10px 14px", maxWidth: "75%", wordBreak: "break-word" }}>
              <div style={{ fontSize: 11, fontWeight: 500, color: m.sender_type === "admin" ? "#2563EB" : "#B45309", marginBottom: 4 }}>{m.sender_name || (m.sender_type === "admin" ? t("tk.supportName") : t("tk.you"))}</div>
              <div style={{ fontSize: 14, color: "#1F2937", lineHeight: 1.5, whiteSpace: "pre-wrap" }}>{m.message}</div>
              {m.attachment_url && <div style={{ marginTop: 6 }}><a href={m.attachment_url} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: "#3B82F6" }}>{t("tk.attachment")}</a></div>}
              <div style={{ fontSize: 10, color: "#9CA3AF", marginTop: 4, textAlign: "right" }}>{fmtDate(m.created_at)}</div>
            </div>
          </div>
        )) : <div style={{ textAlign: "center", color: "#9CA3AF", fontSize: 14, padding: 20 }}>{t("tk.noMessages")}</div>}
      </div>

      {/* Input mensagem ou avaliação */}
      {detail.status === "fechado" ? (
        <div style={{ background: "#FFF", border: "1px solid #E8EAF0", borderRadius: 10, padding: 20 }}>
          {detail.rating ? (
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: 14, color: "#6B7280", marginBottom: 6 }}>{t("tk.rated")}</div>
              <div style={{ fontSize: 28 }}>{"★".repeat(detail.rating)}{"☆".repeat(5 - detail.rating)}</div>
              {detail.rating_comment && <div style={{ fontSize: 13, color: "#9CA3AF", marginTop: 6 }}>"{detail.rating_comment}"</div>}
            </div>
          ) : (
            <div>
              <div style={{ fontSize: 14, color: "#374151", marginBottom: 10, fontWeight: 500 }}>{t("tk.ratePrompt")}</div>
              <div style={{ display: "flex", gap: 4, marginBottom: 10, justifyContent: "center" }}>
                {[1,2,3,4,5].map(n => (
                  <span key={n} onClick={() => setRating(n)} style={{ fontSize: 32, cursor: "pointer", color: n <= rating ? "#F59E0B" : "#E2E8F0", transition: "color 0.15s" }}>{n <= rating ? "★" : "☆"}</span>
                ))}
              </div>
              {rating > 0 && (
                <div>
                  <textarea value={ratingComment} onChange={e => setRatingComment(e.target.value)} placeholder={t("tk.commentPh")} rows={2} style={{ ...iStyle, marginBottom: 10 }} />
                  <button onClick={submitRating} disabled={loading} style={{ ...pBtn, width: "100%", opacity: loading ? 0.6 : 1 }}>{loading ? t("tk.sending") : t("tk.sendRating")}</button>
                </div>
              )}
            </div>
          )}
        </div>
      ) : (
        <div style={{ display: "flex", gap: 8 }}>
          <textarea value={msg} onChange={e => setMsg(e.target.value)} onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendMessage(); } }} placeholder={t("tk.msgPh")} rows={2} style={{ ...iStyle, flex: 1 }} />
          <button onClick={sendMessage} disabled={loading || !msg.trim()} style={{ ...pBtn, alignSelf: "flex-end", opacity: loading || !msg.trim() ? 0.5 : 1 }}>{t("tk.send")}</button>
        </div>
      )}
    </div>
  );

  // === LISTA DE TICKETS ===
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18 }}>
        <div><h1 style={h1Style}>{t("tk.title")}</h1><div style={subStyle}>{t("tk.count",{n:tickets.length})}</div></div>
        <button onClick={() => setShowNew(true)} style={pBtn}>{t("tk.new")}</button>
      </div>

      {/* Tabs */}
      <div style={{ display: "flex", gap: 20, marginBottom: 18, borderBottom: "1px solid #E8EAF0", paddingBottom: 0 }}>
        {[["aberto", t("tk.tabOpen")], ["fechado", t("tk.tabClosed")]].map(([k, l]) => (
          <span key={k} onClick={() => setTab(k)} style={{ fontSize: 14, cursor: "pointer", paddingBottom: 10, color: tab === k ? "#B45309" : "#9CA3AF", fontWeight: tab === k ? 500 : 400, borderBottom: tab === k ? "2px solid #F59E0B" : "2px solid transparent" }}>{l}</span>
        ))}
      </div>

      {/* Lista */}
      {tickets.length === 0 ? (
        <div style={{ textAlign: "center", color: "#9CA3AF", fontSize: 14, padding: 40 }}>
          {tab === "aberto" ? t("tk.noneOpen") : t("tk.noneClosed")}
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {tickets.map(t => (
            <div key={t.id} onClick={() => loadDetail(t.id)} style={{ ...cardStyle, display: "flex", justifyContent: "space-between", alignItems: "center" }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)"}
              onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}>
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                  <span style={{ fontSize: 12, color: "#9CA3AF" }}>#{t.id}</span>
                  <span style={{ fontSize: 14, fontWeight: 500, color: "#1F2937" }}>{t.subject}</span>
                </div>
                <div style={{ display: "flex", gap: 12 }}>
                  <span style={{ fontSize: 12, color: statusColors[t.status], fontWeight: 500 }}>● {statusLabels(t.status)}</span>
                  <span style={{ fontSize: 12, color: priorityColors[t.priority], textTransform: "capitalize" }}>{t("tk.pr_" + t.priority)}</span>
                  <span style={{ fontSize: 12, color: "#9CA3AF" }}>{fmtDate(t.created_at)}</span>
                </div>
              </div>
              {t.status === "fechado" && t.rating && (
                <div style={{ fontSize: 14, color: "#F59E0B" }}>{"★".repeat(t.rating)}</div>
              )}
              <span style={{ fontSize: 18, color: "#D1D5DB", marginLeft: 8 }}>›</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
